module.exports = __webpack_public_path__ + "img/zztbg-2.3a808c04.png";